import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { useThemeMode } from '../../../../_metronic/partials'

const StorageCardSkeleton = () => {
    const { mode } = useThemeMode()
    return (
        <>
            <div className={`d-flex card p-4 ${mode === 'dark' ? 'bg-light' : ''}`}>
                <div className='d-flex flex-md-row flex-column justify-content-between'>
                    <div className='d-flex gap-4 align-items-center mb-md-0 mb-4 me-md-auto me-4'>
                        <>
                            <div className='d-none d-md-block' style={{ width: '15%', minWidth: '80px', maxWidth: '90px', height: '80px' }}>
                                <Skeleton
                                    width={80}
                                    height={80}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    className=''
                                />
                            </div>
                            <div className='d-block d-md-none' style={{ width: '15%', minWidth: '80px', maxWidth: '90px' }}>
                                <Skeleton
                                    width={80}
                                    height={80}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    className=''
                                />
                            </div>
                        </>
                        <div className='d-flex flex-column w-100'>
                            <>
                                <div className='d-none d-md-block'>
                                    <Skeleton
                                        width={150}
                                        height={20}
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        className='mb-2'
                                    />
                                </div>
                                <div className='d-md-none d-block'>
                                    <Skeleton
                                        width={`100%`}
                                        height={20}
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        className='mb-2'
                                    />
                                </div>
                            </>
                            <>
                                <div className='d-none d-md-block w-100'>
                                    <Skeleton
                                        width={300}
                                        height={20}
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        className='mb-2'
                                    />
                                </div>
                                <div className='d-md-none d-block'>
                                    <Skeleton
                                        width={'100%'}
                                        height={40}
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        className='mb-2'
                                    />
                                </div>
                            </>
                        </div>
                    </div>
                    {/* <div className='d-flex align-items-start'>
                        <button
                            className='btn bg-primary text-white custom-button-property font-size-13 w-100 text-nowrap'
                            onClick={() => setIsModalActive(true)}
                        >
                            {formatMessage({ id: 'Buy More' })}
                        </button>
                    </div> */}
                </div>
                <div className='mt-4'>
                    <div className='d-flex flex-md-row flex-column justify-content-between'>

                        <>
                            <div className='d-none d-md-block'>
                                <Skeleton
                                    width={350}
                                    height={20}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    className='mb-2'
                                />
                            </div>
                            <div className='d-block d-md-none'>
                                <Skeleton
                                    width={'100%'}
                                    height={20}
                                    baseColor='var(--kt-skeleton-bg-color)'
                                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    className='mb-2'
                                />
                            </div>
                        </>
                        <div className='d-flex justify-content-end'>

                            <Skeleton
                                width={150}
                                height={20}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                className='mb-2'
                            />

                        </div>
                    </div>
                    <Skeleton
                        width={'100%'}
                        height={10}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        className='mb-2'
                    />
                    <div className='d-flex'>
                        <Skeleton
                            width={280}
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className='mb-0'
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default StorageCardSkeleton
